import { render, staticRenderFns } from "./miniCloutFloor.vue?vue&type=template&id=0195a616&scoped=true"
import script from "./miniCloutFloor.vue?vue&type=script&lang=js"
export * from "./miniCloutFloor.vue?vue&type=script&lang=js"
import style0 from "./miniCloutFloor.vue?vue&type=style&index=0&id=0195a616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0195a616",
  null
  
)

export default component.exports